(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tipset/assets/javascripts/models/bomben-match.js') >= 0) return;  svs.modules.push('/modules/tipset/assets/javascripts/models/bomben-match.js'); 
(function(Backbone, _, svs) {
  'use strict';

  svs.tipset.models.BombenMatch = Backbone.Model.extend({
    initialize: function() {
      this.listenTo(
        svs.tipset.models.bombenXperten,
        'sync change:hasXpertValues',
        this.setXpertData
      );
    },

    setXpertData: function() {
      if (svs.tipset.models.bombenXperten.get('hasXpertValues')) {
        this.parseData(
          svs.tipset.models.bombenXperten.getXpertenData(
            this.get('eventNumber') - 1
          )
        );
      } else {
        this.unset('home');
        this.unset('away');
        this.unset('tied');
      }
    },

    parseData: function(xpertenData) {
      var home = [],
        away = [],
        tied = [],
        numberOfRows = 0;
      _.each(xpertenData, function(data) {
        if (data[0] > data[1]) {
          home.push(data);
        }
        if (data[0] < data[1]) {
          away.push(data);
        }
        if (data[0] == data[1]) {
          tied.push(data);
        }
      });

      home = home.sort(sortXpert);
      away = away.sort(sortXpert);
      tied = tied.sort(sortXpert);

      numberOfRows = Math.max(home.length, away.length, tied.length);

      home = this.fillWithEmptyRows(home, numberOfRows);
      away = this.fillWithEmptyRows(away, numberOfRows);
      tied = this.fillWithEmptyRows(tied, numberOfRows);

      this.set({
        home: home,
        away: away,
        tied: tied
      });

      function sortXpert(a, b) {
        if (a[0] < b[0]) {
          return -1;
        }
        if (a[0] == b[0] && a[1] > b[1]) {
          return 1;
        }
        if (a[0] == b[0]) {
          return -1;
        }
        if (a[0] > b[0]) {
          return 1;
        }
      }
    },

    fillWithEmptyRows: function(array, maxRows) {
      if (array.length !== maxRows) {
        for (var i = array.length; i < maxRows; i++) {
          array.push(['', '']);
        }
      }
      return array;
    }
  });
})(Backbone, _, svs);

 })(window);